import { stringifyQs } from "@dashboard/utils/urls";

export const cmsSection = "/cms";

export type CmsTab = "banners" | "shorts" | "slots" | "vacations" | "picks" | "locations";

export interface CmsUrlQueryParams {
  tab?: CmsTab;
  action?: "add" | "edit" | "delete";
  id?: string;
}

export const cmsPath = cmsSection;

export const cmsUrl = (params?: CmsUrlQueryParams) =>
  cmsPath + (params ? "?" + stringifyQs(params) : "");
